import {
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  MODAL_INTERACTION,
} from '../actions/constants';
import { REARRANGE_COLUMNS } from '../util/enums/EnumLayers';
import ModalRearrangeColumns from '../components/modals/ModalRearrangeColumns';
import Column from '../util/Column';

const INITIAL_STATE = {
  initialOrder: [], // ordered ColumnName objs (order when modal loaded)
  order: [], // ordered ColumnName objs (order that should be saved)
  readyForSave: false,
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'orderChanged':
      return { ...state, order: payload.order, readyForSave: true };
    default:
      return state;
  }
}

const modalRearrangeColumns = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalRearrangeColumns) {
        const parentColumnNames = action.payload.json.map((c) =>
          Column.build(c).name(),
        );
        if (action.payload.existingLayer) {
          // existing
          const existingColumnNames =
            action.payload.existingLayer.columnNames();
          // don't include columns that no longer exist
          const missingRemoved = existingColumnNames.filter(
            (cn) => parentColumnNames.findIndex((pc) => pc.equals(cn)) !== -1,
          );
          // add any new columns
          const missing = parentColumnNames.filter(
            (pc) => missingRemoved.findIndex((cn) => cn.equals(pc)) === -1,
          );
          const order = [...missingRemoved, ...missing];
          return {
            ...INITIAL_STATE,
            initialOrder: order,
            order,
            readyForSave: true,
          };
        }
        // new layer
        return { ...INITIAL_STATE, initialOrder: parentColumnNames };
      }
      return state;
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== REARRANGE_COLUMNS) {
        return state;
      }
      return interaction(state, action.payload.props);
    }
    default:
      return state;
  }
};

export default modalRearrangeColumns;
